import { buildMock } from 'utils'

export default buildMock({
  id: 'authorization_id',
  level: 4,
  updated_at: 1590342235,
})
